import { useMemo } from "react";
import { useVisible } from "../../../../../utils/hooks/useVisible";
import AddPayCode from "../../../../Request/AddPayCode";

export const usePayCodeRequestModal = () => {
    const { visible, open, close, selected } = useVisible();

    const modal = useMemo(() => {
        if (!visible) {
            return null;
        }
        return (
            <AddPayCode
                isOpen={visible}
                onClose={close}
                user={selected}
            />
        );
    }, [visible, close, selected]);

    return [open, modal];
};